import React from 'react'
import PropTypes from 'prop-types'
import { EMPTY, isBlank } from './detailFormat'

// One label/value pair. `source` is the stored field it comes from (e.g.
// "UserInfo_v3.totalTime"), shown on hover so a value on screen can be traced
// back to the database without reading the component.
const DetailFieldComponent = ({ label, value, source, action, wide, children }) => {
  const content = children !== undefined ? children : value
  return (
    <div className={'detail-field' + (wide ? ' detail-field-wide' : '')}>
      <div className="detail-label" title={source}>
        {label}
        {action && <span className="detail-action ms-2">{action}</span>}
      </div>
      <div className="detail-value">
        {isBlank(content) || content === false
          ? <span className="text-muted">{EMPTY}</span>
          : content}
      </div>
    </div>
  )
}

DetailFieldComponent.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node,
  source: PropTypes.string,
  action: PropTypes.node,
  wide: PropTypes.bool,
  children: PropTypes.node
}

// Lays fields out in as many columns as the card is wide enough for.
export const DetailGrid = ({ children }) => (
  <div className="detail-grid">{children}</div>
)

DetailGrid.propTypes = {
  children: PropTypes.node
}

export default DetailFieldComponent
